import { RootState } from "../../store.types";
import { State } from "./auth.types";

export const getCurrentState = (state: RootState): State => state.auth;
export const getUser = (state: RootState) => getCurrentState(state).user;
export const isAuthLoading = (state: RootState) =>
  getCurrentState(state).isAuthLoading;
// Account sospeso per mancato pagamento: blocca le operazioni + mostra il banner.
export const isSuspended = (state: RootState) =>
  getCurrentState(state).user?.billingInfo?.billingStatus === "suspended";
